import { environment } from '@environments/environment';
import { AppRoutesEnum, CurrentUser } from '@shared/types';
import { AppNavigation } from '../types';
import { AppNavigationOptionsEnum } from '../types/navigation-options.enum';

export class AppNavigationCreator {
    static create(item: AppNavigation) {
        return {
            ...item,
        };
    }

    static createMyStrainsNavigation(): AppNavigation[] {
        return [
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_STRAINS_LISTING,
                label: 'toolbar.myStrains.myStrains',
                url: environment.colonyUrlStrains,
                icon: '',
                internalRoute: false,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_STRAINS_GENE_MUTATIONS,
                label: 'toolbar.myStrains.geneMutations',
                url: environment.colonyUrlGeneMutations,
                icon: '',
                internalRoute: false,
            }),
        ];
    }

    static createMyCagesNavigation(): AppNavigation[] {
        return [
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_CAGES_LISTING,
                label: 'toolbar.myCages.listView',
                url: environment.colonyUrlCagesList,
                icon: '',
                internalRoute: false,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_CAGES_MAP_VIEW,
                label: 'toolbar.myCages.mapView',
                url: environment.colonyUrlCagesMapView,
                icon: '',
                internalRoute: false,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.MY_CAGES_WORKBENCH,
                label: 'toolbar.myCages.workbench',
                url: environment.colonyUrlCagesWorkbench,
                icon: '',
                internalRoute: false,
            }),
        ];
    }

    static createMyAdministrationNavigation(currentUser: CurrentUser): AppNavigation[] {
        const isSuperAdmin = currentUser?.isColonySuperAdmin || false;
        const isGroupAdmin = currentUser?.isColonyGroupAdmin || false;
        const isUserAdmin = currentUser?.isColonyUserAdmin || false;
        const isMouseImportAdmin = currentUser?.isColonyMouseImportAdmin || false;
        const isTlAdmin = currentUser?.isTLAdmin || false;
        const isColonyWaiverAdmin = currentUser?.isColonyWaiverAdmin || false;

        return [
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.ADMINISTRATION_USERS,
                label: 'toolbar.administration.users',
                url: environment.colonyUrlAdministrationUsers,
                icon: '',
                internalRoute: false,
                isHidden: !isSuperAdmin && !isUserAdmin && !isColonyWaiverAdmin,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.ADMINISTRATION_GROUPS,
                label: 'toolbar.administration.groups',
                url: AppRoutesEnum.GROUPS,
                icon: '',
                internalRoute: true,
                isHidden: !isSuperAdmin && !isGroupAdmin && !isColonyWaiverAdmin,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.ADMINISTRATION_AUDIT_LOG,
                label: 'toolbar.administration.auditLog',
                url: environment.colonyUrlAdministrationAuditLog,
                icon: '',
                internalRoute: false,
                isHidden: !isSuperAdmin && !isGroupAdmin && !isUserAdmin && !isColonyWaiverAdmin,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.ADMINISTRATION_MOUSE_IMPORT,
                label: 'toolbar.administration.mouseImport',
                url: environment.colonyUrlAdministrationMouseImport,
                icon: '',
                internalRoute: false,
                isHidden: !isSuperAdmin && !isMouseImportAdmin && !isColonyWaiverAdmin,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.ADMINISTRATION_RELOAD_GROUP_DATA,
                label: 'toolbar.administration.reloadGroupData',
                url: environment.colonyUrlAdministrationReloadGroupData,
                icon: '',
                internalRoute: false,
                isHidden: !isSuperAdmin && !isColonyWaiverAdmin,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.ADMINISTRATION_BANNER_MAINTENANCE,
                label: 'toolbar.administration.bannerMaintenance',
                url: environment.colonyUrlAdministrationBannerMaintenance,
                icon: '',
                internalRoute: false,
                isHidden: !isSuperAdmin && !isColonyWaiverAdmin,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.ADMINISTRATION_SCHEDULED_JOBS,
                label: 'toolbar.administration.scheduledJobs',
                url: environment.colonyUrlAdministrationScheduledJobs,
                icon: '',
                internalRoute: false,
                isHidden: !isSuperAdmin && !isColonyWaiverAdmin,
            }),
            AppNavigationCreator.create({
                id: AppNavigationOptionsEnum.ADMINISTRATION_TICKET_LAB,
                label: 'toolbar.administration.ticketLab',
                url: AppRoutesEnum.TL_HUB,
                icon: '',
                internalRoute: true,
                isHidden: !isTlAdmin,
            }),
        ];
    }
}
